module.exports = __webpack_public_path__ + "img/henrikslide2.331dc75a.png";